import React, { Component } from 'react'
import { func } from 'prop-types'
import Modal from 'react-modal'
import { Button } from 'components/base'
import { MODAL_DEFAULT_STYLE } from 'components/Utils/Modal/style'

export default class MandatoryUpdateModal extends Component {
  static propTypes = {
    onCountDownEnd: func.isRequired,
  }

  static defaultProps = {
    onCountDownEnd: () => window.location.reload(),
  }

  constructor(props) {
    super(props)
    this.state = {
      countdown: 60,
    }
  }

  componentDidMount() {
    this.handle = setInterval(this.tick, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.handle)
  }

  render() {
    const style = {
      content: {
        ...MODAL_DEFAULT_STYLE.content,
        width: 400,
        zIndex: 1000,
      },
      overlay: {
        ...MODAL_DEFAULT_STYLE.overlay,
        zIndex: 999,
      },
    }
    return (
      <Modal style={style} isOpen={true}>
        <div className="padding-large center-text">
          <h1>A mandatory update is available</h1>
          <div className="margin-vertical-normal">
            Your version will automatically be updated in {this.state.countdown}{' '}
            seconds
          </div>
          <div className="flexbox flexbox-justify-center">
            <Button.Primary onClick={this.props.onCountDownEnd}>
              Use the new version now!
            </Button.Primary>
          </div>
        </div>
      </Modal>
    )
  }

  tick = () => {
    if (this.state.countdown <= 0) {
      clearInterval(this.handle)
      this.props.onCountDownEnd()
      return
    }
    this.setState(state => ({ countdown: state.countdown - 1 }))
  }
}
